import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, of, filter } from 'rxjs';
import { StorageService } from 'src/app/_services/storage.service';
import { environment } from 'src/environments/environment';
const { API_URLBLAZE, API_URL } = environment;

export interface CustomerSearchRequest {
    userType: string;
    contactNumber?: string;
    governmentId?: string;
    walletId?: string;
}

@Injectable({
    providedIn: 'root'
})
export class UserDashboardService {
    constructor(private http: HttpClient, private storageService: StorageService, private router: Router) { }

    //Search
    searchCustomer(searchRequest: CustomerSearchRequest): Observable<any> {
        const url = `${API_URLBLAZE}/user/customer-support/searchCustomer`;
        return this.http.post(url, searchRequest).pipe(catchError(this.handleError()));
    }

    getUserId(field : string, value: string, userType: string) {
        var url;
        switch(field){
            case "MOBILE":
                url = `${API_URLBLAZE}/user/customer-support/findUserIdByMobileNumber?mobileNumber=${value}&userType=${userType}`;
                break;
            case "EMAIL":
                url = `${API_URLBLAZE}/user/customer-support/findUserIdByEmail?email=${value}&userType=${userType}`;
                break;
            case "WALLET":
                url = `${API_URLBLAZE}/transaction/customer-support/findUserIdByWalletId?walletId=${value}&userType=${userType}`;
                break;
            case "CINE":
                url = `${API_URLBLAZE}/user/customer-support/findUserIdByCineId?cineId=${value}&userType=${userType}`;
                break;
            default:
                return null;
        }
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get User Details
    getUserDetails(userId:string, userType: string, mobileNumber: string) {
        if(userType=='CUSTOMER'){
            var url = `${API_URLBLAZE}/user/screening/userinfo/${mobileNumber}`;
         //   var url = `http://localhost:8082/user/screening/userinfo/${userId}`;
            return this.http.get(url).pipe(catchError(this.handleError()));
        }else{
            var url = `${API_URLBLAZE}/user/merchant/getMerchant?userId=${userId}`;
            return this.http.get(url).pipe(catchError(this.handleError()));
        }
    }

    //Get Device Info
    getDeviceInfoDetails(userId: string) {
        var url = `${API_URLBLAZE}/user/customer-support/deviceInfo/${userId}`;
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Wallet Details
    getWalletDetails(userId: string) {
        var url = `${API_URLBLAZE}/transaction/wallet/findWalletDetailsByUserId/${userId}`;
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Beneficiary Details
    getBeneficiaryDetails(userId: string, international?: boolean , filters?: any) {
        var url = `${API_URLBLAZE}/product/beneficiary/findByUserIdWithFilters/${userId}`;
        let queryParams: string[] = [];
        if (international !== undefined) {
            queryParams.push(`international=${international}`);
        }
        if (filters) {
            if (filters.relation) {
                queryParams.push(`relation=${filters.relation}`);
            }
            if (filters.status) {
                queryParams.push(`status=${filters.status}`);
            }
            if (filters.bankType) {
                queryParams.push(`bankType=${filters.bankType}`);
            }
            if (filters.countryId) {
                console.log('Adding country filter:', filters.countryId);
                queryParams.push(`bankBranch.bank.country.id=${filters.countryId}`);
            }
        }

        if (queryParams.length > 0) {
            url += '?' + queryParams.join('&');
        }

        console.log('Final beneficiary URL:', url);
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Relationships
    getRelationships() {
        const url = `${API_URLBLAZE}/transaction/helper/fund-purpose/mappings?purposeType=RELATIONSHIP&page_no=0&page_size=10`;
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Merchant Documents
    // getDocuments(userId: string) {
    //     var url = `${API_URL}/getKyc-DocumentList`;
    //     return this.http.post(url, { businesstypeId: 1, merchantId: userId }).pipe(catchError(this.handleError()));
    // }

      getDocuments(userId: string) {
      //   var url = `${API_URL}/user/common/kyc-document-list"t`;
       var url = `${API_URLBLAZE}/user/common/kyc-document-list"`;
        return this.http.post(url, { businesstypeId: 1, merchantId: userId }).pipe(catchError(this.handleError()));
    }

    //Download
    download(url: string, filename: string){
        console.log(`Download ${url}`);
        const formData = new FormData();
        formData.append('mid', url);
        formData.append('docname', filename);
        var url = `${API_URL}/download-uploadfiles`;
        return this.http.post(url, formData).pipe(catchError(this.handleError()));
    }

    //PII Audit - Log access to PII data
    logPiiAccess(auditData: any) {
        const url = `${API_URLBLAZE}/audit/pii/log-access`;
        return this.http.post(url, auditData).pipe(catchError(this.handleError()));
    }

    //PII Audit - Get audit reasons
    getAuditReasons() {
        const url = `${API_URLBLAZE}/audit/pii/reasons`;
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    //Get Transaction Report List by userId with pagination
    getTransactionReportListForCustomer(userId: string, page_size: number, page_no: number, productCode?: string, filters?: any) {
        let url = `${API_URLBLAZE}/transaction/transaction-report/customer?page_size=${page_size}&page_no=${page_no}&userId=${userId}&sort_dir=DESC&sort_column=createDate`;
        if (productCode) {
            url += `&productCode=${productCode}`;
        }
        if (filters) {
            if (filters.createDate) {
                url += `&createDate=${filters.createDate}`;
            }
            if (filters.txnId) {
                url += `&txnId=${filters.txnId}`;
            }
            if (filters.originalTxnId) {
                url += `&originalTxnId=${filters.originalTxnId}`;
            }
            if (filters.status) {
                url += `&status=${filters.status}`;
            }
            if (filters.productCode) {
                url += `&productCode=${filters.productCode}`;
            }
        }
        console.log(url);
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    // Get Transaction Report List by userId with pagination
    getTransactionReportListForMerchant(userId: string, page_size: number, page_no: number) {
        const url = `${API_URLBLAZE}/transaction/transaction-report/merchant?page_size=${page_size}&page_no=${page_no}&userId=${userId}&sort_dir=DESC&sort_column=createDate`;
        console.log(url);
        return this.http.get(url).pipe(catchError(this.handleError()));
    }

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: HttpErrorResponse): Observable<T> => {
            if (error.status == 401) {
                this.storageService.clean()
                this.router.navigate(['/auth/login']);
            }
            result = error?.error;
            return of(result as T);
        };
    }
}
